import React, { FC } from 'react';
import { getClientsFullTree, getClientsFullTreeV2 } from '../api';

import { Action } from '../controllers/app.controller';
import { useFlags } from '../feature-flags/main';

export interface ClientQueryProps {
  clientId: number | undefined;
  onError: (err: any) => void;
  dispatch: React.Dispatch<Action>;
}

export const ClientQuery: FC<ClientQueryProps> = props => {
  const { 'membership-single-source-of-truth-in-eligibility': membershipSingleSourceOfTruthInEligibility } = useFlags();

  React.useEffect(() => {
    if (!props.clientId) {
      props.onError(new Error('No clientId assigned to user'));
    } else {
      if (membershipSingleSourceOfTruthInEligibility) {
        getClientsFullTreeV2(props.clientId)
          .then(results =>
            props.dispatch({
              type: 'receivedClientFullTreeResults',
              results,
              isMembershipSingleSourceOfTruthInEligibility: true,
            }),
          )
          .catch(props.onError);
      } else {
        getClientsFullTree(props.clientId)
          .then(results =>
            props.dispatch({
              type: 'receivedClientFullTreeResults',
              results,
              isMembershipSingleSourceOfTruthInEligibility: false,
            }),
          )
          .catch(props.onError);
      }
    }
  }, [props.clientId, membershipSingleSourceOfTruthInEligibility]);

  return null;
};
